"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = exports.Vesting = exports.VestingType = exports.VestingSchedule = exports.Model = void 0;
var schema_1 = require("@solvei/borsh/schema");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var bn_js_1 = __importDefault(require("bn.js"));
var utils_1 = require("./utils");
var Model = /** @class */ (function () {
    function Model() {
    }
    return Model;
}());
exports.Model = Model;
var VestingSchedule = /** @class */ (function () {
    function VestingSchedule(initial_unlock, start_time, end_time, unlock_period, cliff) {
        this.initial_unlock = initial_unlock;
        this.start_time = start_time;
        this.end_time = end_time;
        this.unlock_period = unlock_period;
        this.cliff = cliff;
    }
    VestingSchedule.prototype.calculateUnlockedPart = function (now) {
        if (now.lt(this.start_time))
            return new bignumber_js_1.default(0.0);
        if (now.lt(this.cliff))
            return new bignumber_js_1.default(this.initial_unlock);
        if (now.gt(this.end_time))
            return new bignumber_js_1.default(1.0);
        var total_unlocks_count = new bignumber_js_1.default(this.end_time.sub(this.cliff).div(this.unlock_period).toString());
        total_unlocks_count = total_unlocks_count.plus(1); // for unlock immideately at the end of a cliff
        if (this.end_time.sub(this.cliff).mod(this.unlock_period).gtn(0)) {
            total_unlocks_count = total_unlocks_count.plus(1); // for a last non-full period
        }
        var part_per_unlock = new bignumber_js_1.default(1.0 - this.initial_unlock).div(total_unlocks_count);
        var elapsed_unlocks = new bignumber_js_1.default(now.sub(this.cliff).div(this.unlock_period).toString());
        elapsed_unlocks = elapsed_unlocks.plus(1); // unlock immideately at the end of a cliff
        return elapsed_unlocks
            .multipliedBy(part_per_unlock)
            .plus(this.initial_unlock);
    };
    VestingSchedule.space = 40;
    __decorate([
        (0, schema_1.field)(utils_1.FloatAsU64Creator)
    ], VestingSchedule.prototype, "initial_unlock", void 0);
    __decorate([
        (0, schema_1.field)({ type: "u64" })
    ], VestingSchedule.prototype, "start_time", void 0);
    __decorate([
        (0, schema_1.field)({ type: "u64" })
    ], VestingSchedule.prototype, "end_time", void 0);
    __decorate([
        (0, schema_1.field)({ type: "u64" })
    ], VestingSchedule.prototype, "unlock_period", void 0);
    __decorate([
        (0, schema_1.field)({ type: "u64" })
    ], VestingSchedule.prototype, "cliff", void 0);
    return VestingSchedule;
}()); //40 bytes
exports.VestingSchedule = VestingSchedule;
var VestingType = /** @class */ (function () {
    function VestingType(properties) {
        if (properties) {
            this.is_initialized = properties.is_initialized;
            this.vesting_schedule = properties.vesting_schedule;
            this.locked_tokens_amount = properties.locked_tokens_amount;
            this.administrator = properties.administrator;
            this.token_pool = properties.token_pool;
            this.required_signers = properties.required_signers;
        }
    }
    VestingType.space = 145;
    __decorate([
        (0, schema_1.field)({ type: "u8" })
    ], VestingType.prototype, "is_initialized", void 0);
    __decorate([
        (0, schema_1.field)({ type: VestingSchedule })
    ], VestingType.prototype, "vesting_schedule", void 0);
    __decorate([
        (0, schema_1.field)({ type: "u64" })
    ], VestingType.prototype, "locked_tokens_amount", void 0);
    __decorate([
        (0, schema_1.field)(utils_1.PublicKeyCreator)
    ], VestingType.prototype, "administrator", void 0);
    __decorate([
        (0, schema_1.field)(utils_1.PublicKeyCreator)
    ], VestingType.prototype, "token_pool", void 0);
    __decorate([
        (0, schema_1.field)(utils_1.PublicKeyCreator)
    ], VestingType.prototype, "required_signers", void 0);
    return VestingType;
}());
exports.VestingType = VestingType;
var Vesting = /** @class */ (function () {
    function Vesting(properties) {
        if (properties) {
            this.is_initialized = properties.is_initialized;
            this.is_active = properties.is_active;
            this.total_tokens = properties.total_tokens;
            this.withdrawn_tokens = properties.withdrawn_tokens;
            this.token_account = properties.token_account;
            this.vesting_type_account = properties.vesting_type_account;
        }
    }
    Vesting.prototype.calculate_available_to_withdraw_amount = function (schedule, now) {
        if (!this.total_tokens || !this.withdrawn_tokens)
            throw Error("Deserialization error");
        var unlocked_part = schedule.calculateUnlockedPart(new bn_js_1.default(now));
        var totalTokens = new bignumber_js_1.default(this.total_tokens.toString());
        var unlocked_amount = new bn_js_1.default(totalTokens
            .multipliedBy(unlocked_part)
            .dp(0, bignumber_js_1.default.ROUND_FLOOR)
            .toString());
        unlocked_amount = bn_js_1.default.min(unlocked_amount, this.total_tokens); // safeguard check
        return bn_js_1.default.max(unlocked_amount.sub(this.withdrawn_tokens), new bn_js_1.default(0));
    };
    Vesting.space = 82;
    __decorate([
        (0, schema_1.field)({ type: "u8" })
    ], Vesting.prototype, "is_initialized", void 0);
    __decorate([
        (0, schema_1.field)({ type: "u8" })
    ], Vesting.prototype, "is_active", void 0);
    __decorate([
        (0, schema_1.field)({ type: "u64" })
    ], Vesting.prototype, "total_tokens", void 0);
    __decorate([
        (0, schema_1.field)({ type: "u64" })
    ], Vesting.prototype, "withdrawn_tokens", void 0);
    __decorate([
        (0, schema_1.field)(utils_1.PublicKeyCreator)
    ], Vesting.prototype, "token_account", void 0);
    __decorate([
        (0, schema_1.field)(utils_1.PublicKeyCreator)
    ], Vesting.prototype, "vesting_type_account", void 0);
    return Vesting;
}());
exports.Vesting = Vesting;
var Config = /** @class */ (function () {
    function Config(properties) {
        if (properties) {
            this.is_initialized = properties.is_initialized;
            this.vesting_stop_enabled = properties.vesting_stop_enabled;
            this.vesting_stop_multisig_enabled =
                properties.vesting_stop_multisig_enabled;
            this.vesting_stop_multisig_withdraw_enabled =
                properties.vesting_stop_multisig_withdraw_enabled;
        }
    }
    Config.space = 4;
    __decorate([
        (0, schema_1.field)({ type: "u8" })
    ], Config.prototype, "is_initialized", void 0);
    __decorate([
        (0, schema_1.field)({ type: "u8" })
    ], Config.prototype, "vesting_stop_enabled", void 0);
    __decorate([
        (0, schema_1.field)({ type: "u8" })
    ], Config.prototype, "vesting_stop_multisig_enabled", void 0);
    __decorate([
        (0, schema_1.field)({ type: "u8" })
    ], Config.prototype, "vesting_stop_multisig_withdraw_enabled", void 0);
    return Config;
}());
exports.Config = Config;
//# sourceMappingURL=models.js.map